<template>
    <div class="foot_cpright">
        <p>
            <a href="https://beian.miit.gov.cn"
                >版权所有ICP证：浙B2-20110112-14</a
            >
            &nbsp;|&nbsp;
            <img
                src="@/assets/images/beian.png"
                style="display:inline-block;"
            />&nbsp;浙公网安备：33010402000539号&nbsp;|&nbsp;© 2011-2021
            多麦股份
        </p>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.foot_cpright {
    height: 3rem;
    line-height: 3rem;
    background-color: #000;
    color: #fff;
    font-size: 0.875rem;
    font-family: PingFangSC-Regular;
    & p {
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        & a {
            color: #fff;
        }
    }
}
</style>
